/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Document_Pdf_Not_RequestableInputs */

const en_error_document_pdf_not_requestable = /** @type {(inputs: Error_Document_Pdf_Not_RequestableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The PDF cannot be asked for again now: the document has it, is not numbered yet, or its PDF was just asked for and is still in time.`)
};

/**
* | output |
* | --- |
* | "The PDF cannot be asked for again now: the document has it, is not numbered yet, or its PDF was just asked for and is still in time." |
*
* @param {Error_Document_Pdf_Not_RequestableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_document_pdf_not_requestable = /** @type {((inputs?: Error_Document_Pdf_Not_RequestableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Document_Pdf_Not_RequestableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_document_pdf_not_requestable(inputs)
});